import { render, staticRenderFns } from "./CrmTable.vue?vue&type=template&id=6a401af0&scoped=true&"
import script from "./CrmTable.vue?vue&type=script&lang=js&"
export * from "./CrmTable.vue?vue&type=script&lang=js&"
import style0 from "./CrmTable.vue?vue&type=style&index=0&id=6a401af0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a401af0",
  null
  
)

export default component.exports